/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface WebResult {
  code: string;
  msgKey: string;
  success: boolean;
}

export type Map = Record<string, any>;

export type WebResultTaskRewardStatVO = WebResult & {
  obj?: RewardStatVO;
};

export type WebResultTaskKolVO = WebResult & {
  obj?: KolVO[];
};

export type WebResultPointStaticList = WebResult & {
  obj?: PointStaticList;
};

export type WebResultVerifyVO = WebResult & {
  obj?: VerifyVO;
};

export interface PointStaticList {
  /**
   * 今日获得积分
   * @default 0
   * @example 100
   */
  todayReceived?: number;
  /** 积分每日数据 */
  history?: PointsDailyLedger[];
}

export type WebResultCurrentUserVO = WebResult & {
  obj?: CurrentUserVO;
};

export type WebResultTaskTweetVO = WebResult & {
  obj?: string[];
};

export type WebResultTaskRewardVO = WebResult & {
  obj?: Award;
};

export type WebResultActiveTaskVO = WebResult & {
  obj?: Award;
};

export type WebResultCheckInStatusVO = WebResult & {
  obj?: CheckInStatusVO;
};

export interface CheckInStatusVO {
  /**
   * @format int32
   * @example 7
   */
  checkInDays?: number;
  /**
   * true 已签到，false 未签到
   * @example true
   */
  checkIn?: boolean;
  checkInReward?: Award[];
  /** 今日签到奖励类型 */
  todayRewardType?: string;
  /**
   * @format int64
   * @example 1640995200000
   */
  checkInTime?: number;
  icon?: string;
  /**
   * @format int32
   * @example 7
   */
  maxCheckInDays?: number;
  /** 今日签到奖励 */
  todayReward?: string;
  /** 任务标题 */
  title?: string;
  desc?: string;
}

export type WebResultCustomerBindVO = WebResult & {
  obj?: CustomerBindVO;
};

export interface CustomerBindVO {
  cid?: string;
  uid?: string;
  saasId?: string;
  /** 头像 */
  avatar?: string;
  jwt?: string;
  mugenJwt?: string;
  available?: number;
  twitterName?: string;
}

export type WebResultDoTaskVO = WebResult & {
  obj?: DoTaskVO;
};

export interface RewardStatVO {
  expectReward?: number;
}

export interface KolVO {
  userName?: string;
  icon?: string;
  profileUrl?: string;
}

export interface DoTaskVO {
  accessToken?: string;
  refreshToken?: string;
}

export type WebResultTaskVO = WebResult & {
  obj?: TaskListResponse[];
};

export interface TaskListResponse {
  taskId?: string;
  groupId?: string;
  title?: string;
  desc?: string;
  image?: Map;
  labelName?: string;
  labelColor?: string;
  url?: string;
  connectUrl?: string;
  dataUrl?: string;
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  progress?: number;
  /** @format int32 */
  status?: number;
  /** @format int32 */
  rewardStatus?: number;
  /** @format int64 */
  completeTime?: number;
  /** @format int64 */
  endTime?: number;
  domain?: string;
  /** 0:不显示 1:go 2:verify */
  btn?: number;
  /** 是否显示进度条 */
  showProgress?: boolean;
  link?: Map;
  code?: string;
  reward?: number;
  position?: string;
  cycle?: string;
  icon?: string;
  postTaskDesc?: string;
  postTaskReward?: number;
  postTaskCode?: string;
  postTaskStatus?: number;
  /** 未来预计参与人数 */
  predictJoinedCount?: number;
  /** 最近参与用户 */
  joinedRecentUsers?: string[];
  subTask?: TaskSubVO[];
  rewards?: Award[];
  /** @format int32 */
  rewardFrequency?: number;
  /** @format int32 */
  todayTaskStatus?: number;
  area?: string;
}

export interface Award {
  /** 奖品描述 */
  desc?: string;
  /** NFT,TOKEN,POINT */
  type?: string;
  /** 奖励金额 */
  amount?: string;
  currency?: string;
  index?: number;
  /**
   * 1:已发放 0:未发放
   * @format int32
   */
  status?: number;
}

export type WebResultTaskDetailVO = WebResult & {
  obj?: TaskDetailVO;
};

export interface TaskDetailVO {
  taskId?: string;
  title?: string;
  desc?: string;
  login_url?: string;
  image?: Map;
  platform?: string;
  rewardType?: string;
  rewardWay?: string;
  subTasks?: TaskSubVO[];
  rewards?: Award[];
  labelName?: string;
  labelColor?: string;
  /** @format int64 */
  startTime?: number;
  /** @format int64 */
  endTime?: number;
  total?: number;
  process?: number;
  rewardStatus?: number;
}

export interface TaskSubVO {
  code?: string;
  /** 是否显示进度条 */
  showProgress?: boolean;
  groupId?: string;
  link?: Record<string, object>;
  icon?: string;
  title?: string;
  cycle?: string;
  /** @format int32 */
  rewardStatus?: number;
  /** 任务平台 */
  platform?: string;
  /** @format int32 */
  rewardFrequency?: number;
  /** @format int32 */
  limit?: number;
  labelName?: string;
  /**
   * 0:不显示 1:go 2:verify
   * @format int32
   */
  btn?: number;
  dataUrl?: string;
  reward?: string;
  image?: Record<string, object>;
  connectUrl?: string;
  /** @format int64 */
  completeTime?: number;
  labelColor?: string;
  url?: string;
  /** @format int32 */
  todayTaskStatus?: number;
  domain?: string;
  /** @format int32 */
  progress?: number;
  /** @format int64 */
  endTime?: number;
  position?: string;
  taskId?: string;
  rewards?: Award[];
  desc?: string;
  /** @format int32 */
  status?: number;
}

export type WebResultSeriesTaskVO = WebResult & {
  obj?: TaskCodeVO;
};

export interface TaskCodeVO {
  /** 是否签过到 */
  checkIn?: boolean;
  /** 任务id */
  taskId?: string;
  /** 任务标题 */
  title?: string;
  /** 任务描述 */
  desc?: string;
  nodes?: NodeVO[];
  process?: number;
  image?: string[];
}

export interface NodeVO {
  /** 1 */
  index?: number;
  /** 0:无奖品 1:普通奖品 */
  nodeLogo?: number;
}

/** 积分日流水 */
export interface PointsDailyLedger {
  /**
   * 数据发生日期
   * @format int64
   */
  date?: number;
  /**
   * 当日增量
   * @example 100
   */
  increment?: number;
}

export interface CurrentUserVO {
  uid?: string;
  saasId?: string;
  twitterName?: string;
  discordName?: string;
  invitePoint?: number;
  dividePoint?: number;
  /** 用户加成后的积分 */
  available?: number;
  /**
   * pfp 加成
   * @example "100%"
   */
  pfp?: string;
  /**
   * vip 加成
   * @example "100%"
   */
  vip?: string;
  /** 是否为 vip 用户 */
  isVip?: boolean;
  rankValue?: number;
  rankPercent?: string;
  expValue?: number;
  /** 用户加成后的积分 */
  ticketAvailable?: number;
  /** 用户已使用的积分 */
  ticketUsed?: number;
  /** 用户可用的抽奖券 */
  voucherAvailable?: number;
  /** 用户持有的有效额外加成 */
  extraBoostValue?: number;
  /** 用户持有的基础加成 */
  boostValue?: number;
  /** 用户持有的OJO资产 */
  ojoValue?: number;
  /**
   * 用户信用分总分
   * @default 0
   */
  credentialsAvailable?: number;
  /**
   * OSP认证标识
   * @default false
   */
  OSPVerified?: boolean;
  /**
   * X加V认证标识
   * @default false
   */
  XVerified?: boolean;
  /** X加V认证类型 */
  XVerifiedType?: string;
  /** OSP头像 */
  ospAvatar?: string;
}

export interface VerifyVO {
  /** @default false */
  OSPVerified?: boolean;
  /** @default false */
  XVerified?: boolean;
}

export type WebResultTopLadder = WebResult & {
  obj?: LadderVO;
};

export interface LadderVO {
  /** 排行榜数据 */
  myLadder?: TopLadder;
  /**
   * 排行榜最后更新时间
   * @format int64
   */
  lastUpdateTime?: number;
  ladders?: TopLadder[];
}

/** 排行榜数据 */
export interface TopLadder {
  /**
   * 用户ID
   * @example "10023123123221111"
   */
  customerId?: string;
  /**
   * 排名
   * @format int32
   * @example 1
   */
  rank?: number;
  /**
   * 积分数量
   * @example 100
   */
  point?: number;
  /**
   * 等级
   * @example 10
   */
  level?: string;
  /**
   * 自己获得积分数量
   * @example 100
   */
  earnedPoint?: number;
  /**
   * 邀请继承积分数量
   * @example 100
   */
  referralPoint?: number;
  /**
   * 会员奖励
   * @example 100
   */
  memberPoint?: number;
  /**
   * quests aura分数
   * @example 100
   */
  questsPoint?: number;
  /**
   * aura帖子数
   * @example 100
   */
  postCount?: int64;
  /** osp 头像 */
  ospAvatar?: string;
  /** osp handle名 */
  ospHandle?: string;
  /** twitter头像 */
  twitterAvatar?: string;
  /** twitter展示名称 */
  twitterDisplayName?: string;
  /**
   * 排行位置比例
   * @example "0.1~1"
   */
  rankPercent?: number;
}

export type WebResultInvitedRewards = WebResult & {
  obj?: {
    /**
     * 客户ID
     * @example "cid1"
     */
    ownerId?: string;
    /**
     * 积分数量
     * @example 100
     */
    point?: string;
  }[];
};

export type WebResultPopupVO = WebResult & {
  obj?: PopupVO;
};

export interface PopupVO {
  rules?: PopupRulesVO[];
}

export interface PopupRulesVO {
  /** popup id */
  id?: string;
  /** popup scene */
  scene?: string;
  /** popup mode e.g. auto / manual / none */
  mode?: string;
  /** popup priority */
  priority?: number;
  /** popup description */
  description?: string;
  /** popup content */
  content?: string;
  /**
   * popup time
   * @format int64
   */
  popupTime?: number;
}

export type WebResultAssetDetailVO = WebResult & {
  obj?: AssetDetailVO[];
};

export interface AssetDetailVO {
  assetType?: string;
  /**
   * 加成后资产余额
   * @default 0
   */
  boostAvailable?: number;
  /**
   * 可用资产余额
   * @default 0
   */
  available?: number;
  /**
   * 累计已接收的资产
   * @default 0
   */
  totalReceive?: number;
  /**
   * 累计已发送的资产
   * @default 0
   */
  totalSent?: number;
  /**
   * 今日已接收的资产
   * @default 0
   */
  todayReceive?: number;
  yields?: {
    /** @format double */
    pmsYield?: number;
    /** @format double */
    nftYield?: number;
    /** @format double */
    creditYield?: number;
  };
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://api.quests.dev.dipbit.xyz";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Kweb API
 * @version 1.0
 * @license Apache 2.0 (https://www.apache.org/licenses/LICENSE-2.0)
 * @baseUrl http://api.quests.dev.dipbit.xyz
 *
 * The Kweb API v1.0
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  v2 = {
    /**
     * No description
     *
     * @tags TaskV2
     * @name TasksRewardByCodeList
     * @request GET:/v2/tasks/reward/by/code
     * @secure
     */
    tasksRewardByCodeList: (
      query: {
        /** code */
        code: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultTaskRewardStatVO, any>({
        path: `/v2/tasks/reward/by/code`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 刷新认证
     *
     * @tags CustomerV2
     * @name RefreshVerified
     * @summary osp verify
     * @request POST:/v2/customer/refreshVerified
     */
    refreshVerified: (params: RequestParams = {}) =>
      this.request<WebResultVerifyVO, any>({
        path: `/v2/customer/refreshVerified`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  v3 = {
    /**
     * @description 每日积分
     *
     * @tags MemberV3
     * @name PointDaily
     * @summary 每日积分
     * @request GET:/v3/member/points/daily
     */
    pointDaily: (
      query?: {
        /** osp handleName */
        handleName?: string;
        /** osp appId */
        appId?: string;
        /** osp chainId */
        chainId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultPointStaticList, any>({
        path: `/v3/member/points/daily`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 根据客户ID列表查询每个邀请人获得的奖励积分
     *
     * @tags MemberV3
     * @name QueryInvitedRewards
     * @summary 查询邀请人获得的奖励
     * @request GET:/v3/member/invited/rewards
     */
    queryInvitedRewards: (
      query: {
        /**
         * 客户ID列表
         * @example ["cid1","cid2"]
         */
        ownerIds: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultInvitedRewards, any>({
        path: `/v3/member/invited/rewards`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  v4 = {
    /**
     * @description 三方认证登录
     *
     * @tags CustomerV2
     * @name Me
     * @summary get current time
     * @request GET:/v4/customer/me
     */
    me: (
      query?: {
        /** 默认返回 twitterName, 还支持 invite、asset、rank、exp、ticket、all */
        businessType?: string;
        /** osp handleName */
        handleName?: string;
        /** osp appId */
        appId?: string;
        /** osp chainId */
        chainId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultCurrentUserVO, any>({
        path: `/v4/customer/me`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TaskV2
     * @name TasksListList
     * @summary 获取任务列表
     * @request GET:/v4/tasks/list
     */
    tasksListList: (
      query?: {
        /**
         * channel
         * @default "app"
         * @example "app、pc"
         */
        channel?: string;
        /**
         * home
         * @example "home"
         */
        position?: string;
        /**
         * ios/android
         * @example "ios"
         */
        clientType?: string;
        /**
         * app version
         * @example 1
         */
        appVersion?: string;
        /** locale */
        locale?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultTaskVO, any>({
        path: `/v4/tasks/list`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 积分天梯top榜
     *
     * @tags MemberV3
     * @name TopLadder
     * @summary 积分天梯top榜
     * @request GET:/v4/member/top/ladder
     */
    topLadder: (
      query?: {
        /** osp handleName */
        handleName?: string;
        /** osp appId */
        appId?: string;
        /** osp chainId */
        chainId?: string;
        /**
         * 资产类型 默认 POINT
         * @default "POINT"
         */
        assetType?: string;
        /**
         * @format int32
         * @default 100
         */
        limit?: number;
        /**
         * 排序策略，fold：相同分数排名相同， unfold(默认)：相同分数排名不同
         * @default "unfold"
         */
        strategy?: string;
        /** ladder business type */
        businessType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultTopLadder, any>({
        path: `/v4/member/top/ladder`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags TaskV2
     * @name TasksVerifyCreate
     * @summary 做任务
     * @request POST:/v4/tasks/verify
     */
    tasksVerifyCreate: (
      query: {
        /** 任务id */
        taskId: string;
        ext?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultDoTaskVO, any>({
        path: `/v4/tasks/verify`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description check in
     *
     * @tags TaskV2
     * @name CheckIn
     * @summary check in
     * @request POST:/v4/tasks/checkin
     */
    checkIn: (params: RequestParams = {}) =>
      this.request<WebResultActiveTaskVO, any>({
        path: `/v4/tasks/checkin`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description check in
     *
     * @tags TaskV2
     * @name CheckInStatus
     * @summary check in
     * @request GET:/v4/tasks/checkin/status
     */
    checkInStatus: (
      query?: {
        /** 位置 */
        position?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultCheckInStatusVO, any>({
        path: `/v4/tasks/checkin/status`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 领取奖励
     *
     * @tags RewardV2
     * @name ReceiveReward
     * @summary 领取奖励
     * @request POST:/v4/reward/receive
     */
    receiveReward: (
      query: {
        /** 任务id */
        taskId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResult, any>({
        path: `/v4/reward/receive`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 三方认证登录
     *
     * @tags CustomerV2
     * @name AuthToken
     * @summary get twitter/discord token
     * @request POST:/v4/customer/oauth/social/token
     */
    authToken: (
      query: {
        /** twitter、discord、google、facebook */
        app: string;
        /** twitter、discord */
        platform: string;
        /** code(一次性) */
        code: string;
        /** redirectUri */
        redirectUri?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, any>({
        path: `/v4/customer/oauth/social/token`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 用户弹窗
     *
     * @tags CustomerV2
     * @name Popup
     * @summary get user popup
     * @request GET:/v4/customer/popup
     */
    popup: (
      query: {
        /** 弹窗场景 e.g. auraPresent ... */
        scene: string;
        /** 资产类型 e.g. AURA ... */
        assetType?: string;
        /** 资产业务类型 e.g. PRESENT ... */
        assetBusinessType?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultPopupVO, any>({
        path: `/v4/customer/popup`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询用户资产详情
     *
     * @tags Asset
     * @name AssetDetail
     * @summary 查询用户资产详情
     * @request GET:/v4/asset/detail
     */
    assetDetail: (
      query: {
        /** 资产类型 */
        assetTypes: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultAssetDetailVO, any>({
        path: `/v4/asset/detail`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
